<template>
    <views class="point">
        <nav-bar
            title="我的积分"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <tab
            :tabs="tabs"
            :active-name="activeName"
            @change="handleChange">
        </tab>
        <views class="line"></views>
        <point-source v-if="activeName === '积分来源'"></point-source>
        <point-detail v-if="activeName === '积分明细'"></point-detail>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import Tab from '@/components/tab'
import PointSource from './PointSource'
import PointDetail from './PointDetail'
import tools from '@/mixins/tools'
export default {
    components: {
        NavBar,
        Tab,
        PointSource,
        PointDetail
    },
    mixins: [tools],
    data() {
        return {
            activeName: '积分来源',
            tabs: [
                {
                    id: '1',
                    name: '积分来源'
                },
                {
                    id: '2',
                    name: '积分明细'
                }
            ]
        }
    },
    methods: {
        onClickLeft() {
            this.back()
        },
        handleChange(val) {
            this.activeName = val.name
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
